import React, { Fragment, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Popover } from '@material-ui/core';
import { AvailabilityFilterList } from '../AvailabilityFilterList/AvailabilityFilterList';
import { setSearchObject } from '../../redux/actions/equipmentsActions';
import styles from './styles';
import { useTranslation } from 'react-i18next';

function ParseValues(values: any[]) {
  const filter = values.reduce(
    (acc, { metas: place }) => ({
      ...acc,
      ...(!!place.regionId && {
        regions: acc.regions?.includes(place.regionId)
          ? acc.regions
          : [...(acc.regions ?? []), place.regionId],
      }),
      ...(!!place.countryId && {
        countries: acc.countries?.includes(place.countryId)
          ? acc.countries
          : [...(acc.countries ?? []), place.countryId],
      }),
      ...(!!place.stateId && {
        states: acc.states?.includes(place.stateId)
          ? acc.state
          : [...(acc.states ?? []), place.stateId],
      }),
    }),
    {},
  );
  return {
    ...(!!filter.regions?.length && {
      regions: JSON.stringify(filter.regions),
    }),
    ...(!!filter.countries?.length && {
      countries: JSON.stringify(filter.countries),
    }),
    ...(!!filter.states?.length && { states: JSON.stringify(filter.states) }),
  };
}

function RBIAvailabilityButton({
  value,
  textButton = '',
  includeStates = false,
  onChange = (values: any[], parsedValues?: any) => {},
  onApply = () => {},
}: any) {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const classes = styles();
  const [anchorElPopover, setAnchorElPopover] = useState<HTMLElement | null>(
    null,
  );
  const [innerValue, setInnerValue] = useState<any[]>([]);
  const [labelValue, setLabelValue] = useState('');

  const currentValue = useMemo(() => value || innerValue, [value, innerValue]);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setAnchorElPopover(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElPopover(null);
  };

  const handleChange = (values: any[]) => {
    const parsedValues = ParseValues(values);
    if (!value) {
      dispatch(setSearchObject(parsedValues));
      setInnerValue(values);
    }
    onChange(values, parsedValues);
  };

  const onApplyButton = () => {
    handlePopoverClose();
    onApply();

    const slicedValue = currentValue.slice(0, 3);
    const values: string[] = [];

    slicedValue.forEach(slice => {
      values.push(slice.text);
    });

    setLabelValue(values.toString());
  };

  return (
    <Fragment>
      <Button
        variant="outlined"
        classes={{
          label: classes.availabilityFilterLabel,
          root: classes.availabilityButton,
        }}
        onClick={handlePopoverOpen}
      >
        {labelValue ? labelValue : t('app.common.availability')}
      </Button>
      <Popover
        open={Boolean(anchorElPopover)}
        onClose={handlePopoverClose}
        anchorEl={anchorElPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{
          paper: `${classes.searchButtonPopover} `,
        }}
      >
        <div className={`${classes.flexSpaceBetween} ${classes.alignCenter}`}>
          <AvailabilityFilterList
            value={currentValue}
            textButton={textButton}
            includeStates={includeStates}
            onChange={handleChange}
            onApply={onApplyButton}
          />
        </div>
      </Popover>
    </Fragment>
  );
}

export default RBIAvailabilityButton;
